import { Component } from "~/src/internals";

export class Controllable extends Component {}
